import { PatientIntakeConsultationSummaryV4 } from "~/providers/utils/types/patientIntakePreviewTypes";
import {
  PatientScreeningConsultationSummaryV4,
  SUMMARY_TYPE,
} from "~/providers/utils/types/patientPreviewTypes";
import { isFeedbackLiked } from "./isFeedbackLiked";

interface GetConsultationSummaryDataProps {
  screeningSummary: PatientScreeningConsultationSummaryV4;
  intakeSummary?: PatientIntakeConsultationSummaryV4;
}

export const getConsultationSummaryV4Data = ({
  screeningSummary,
  intakeSummary,
}: GetConsultationSummaryDataProps) => {
  const {
    id: screeningSummaryId,
    feedbacks: screeningFeedbacks,
    data: { case_summary: caseSummaryScreening, medications, scores },
    response_themes: responseThemes,
  } = screeningSummary;

  const {
    id: intakeSummaryId,
    feedbacks: intakeFeedbacks,
    data: intakeSummaryData,
  } = { ...intakeSummary };

  const {
    case_summary: caseSummaryIntake,
    functional_domains: functionalDomains,
    health_history: healthHistory,
    personal_life_history: personalLifeHistory,
    treatment_recommendations: treatmentRecommendations,
    ai_informant_conversation_history,
    allergies,
    fillm,
  } = { ...intakeSummaryData };

  const isSummaryLiked = intakeSummaryId
    ? isFeedbackLiked(SUMMARY_TYPE.intake, intakeFeedbacks)
    : isFeedbackLiked(SUMMARY_TYPE.screening, screeningFeedbacks);

  const isTreatmentRecommendationsLiked = isFeedbackLiked(
    SUMMARY_TYPE.treatment_recommendations,
    intakeFeedbacks,
  );

  const caseSummary = caseSummaryIntake ?? caseSummaryScreening;

  return {
    ai_informant_conversation_history,
    allergies,
    caseSummary,
    caseSummaryScreening,
    fillm,
    functionalDomains,
    healthHistory,
    intakeSummaryId,
    isSummaryLiked,
    isTreatmentRecommendationsLiked,
    medications,
    personalLifeHistory,
    potentialAreasOfConcern: [],
    responseThemes,
    scores,
    screeningSummaryId,
    treatmentRecommendations,
  };
};
